import {
  Autocomplete,
  FieldError,
  type Key,
  ListBox,
  ListBoxItem,
  type ListBoxItemProps,
  SelectValue,
  useFilter,
} from 'react-aria-components';
import Check from '@/assets/icons/Check.svg';
import ChevronDown from '@/assets/icons/ChevronDown.svg';
import Search from '@/assets/icons/Search.svg';
import * as Styled from './SearchableSelect.styled';

interface Item {
  id: string;
  name: string;
}

interface SearchableSelectProps {
  dropdownLabel: string;
  handleSelection?: (value: Key | null) => void;
  isRequired?: boolean;
  items: Item[];
  name?: string;
  searchLabel: string;
  value: string;
}

const SelectItem = (props: ListBoxItemProps & { children: string }) => (
  <ListBoxItem {...props} textValue={props.children}>
    {({ isSelected }) => (
      <>
        <span>{props.children}</span>
        <span>{isSelected && <Check />}</span>
      </>
    )}
  </ListBoxItem>
);

export const SearchableSelect = ({
  dropdownLabel,
  handleSelection,
  isRequired = false,
  items,
  name,
  searchLabel,
  value,
}: SearchableSelectProps) => {
  const { contains } = useFilter({ sensitivity: 'base' });

  return items.length > 0 ? (
    <Styled.Field
      isRequired={isRequired}
      name={name}
      onSelectionChange={handleSelection}
      placeholder=""
      defaultSelectedKey={value}
    >
      <Styled.Label>{dropdownLabel}</Styled.Label>
      <FieldError />
      <Styled.Trigger>
        <SelectValue />
        <ChevronDown />
      </Styled.Trigger>
      <Styled.Overlay>
        <Autocomplete filter={contains}>
          <Styled.Filter aria-label={searchLabel} autoFocus>
            <Search aria-hidden />
            <Styled.SearchInput />
          </Styled.Filter>
          <ListBox items={items}>
            {item => <SelectItem>{item.name}</SelectItem>}
          </ListBox>
        </Autocomplete>
      </Styled.Overlay>
    </Styled.Field>
  ) : null;
};
